module.exports = __webpack_public_path__ + "img/flag_de.3e726c2b.svg";